import type { BannerType, GridCommonProps } from '@@partner:types:app'

import React from 'react'

import { Link } from 'react-router-dom'
import { Table, Button, Tag } from 'rsuite'

const { Column, HeaderCell, Cell } = Table

export interface BannerTypesTableProps extends GridCommonProps<BannerType> {}

const BannerTypesTable: React.FC<BannerTypesTableProps> = ({
  tableSort,
  onSortColumn,
  items,
  generateEditUrl,
  loading
}) => {
  return (
    <Table
      autoHeight
      affixHeader
      loading={loading}
      data={items}
      sortColumn={tableSort.fieldName}
      sortType={tableSort.sortType}
      onSortColumn={onSortColumn}
    >
      <Column sortable flexGrow={1} verticalAlign="middle">
        <HeaderCell>ИД</HeaderCell>
        <Cell dataKey="id"></Cell>
      </Column>
      <Column flexGrow={1} verticalAlign="middle">
        <HeaderCell>Тип</HeaderCell>
        <Cell dataKey="label">
          {(rowData) => <Tag color="blue">{rowData.label}</Tag>}
        </Cell>
      </Column>
      <Column sortable flexGrow={1} verticalAlign="middle">
        <HeaderCell>Код типа</HeaderCell>
        <Cell dataKey="code">
          {(rowData) => <Tag color="blue">{rowData.code}</Tag>}
        </Cell>
      </Column>

      <Column flexGrow={2} fixed="right" verticalAlign="middle">
        <HeaderCell>Управление</HeaderCell>
        <Cell>
          {(bannerType: BannerType) => (
            <>
              {generateEditUrl && (
                <Button
                  appearance="primary"
                  color="cyan"
                  as={Link}
                  to={generateEditUrl(bannerType?.id)}
                  size="xs"
                >
                  Изменить
                </Button>
              )}
            </>
          )}
        </Cell>
      </Column>
    </Table>
  )
}

export default BannerTypesTable
